export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_wedding-pricing-hub/artifacts/0qbdzfob_WVE%20LOGO.png";

export function ytId(url) {
  const m = (url || "").match(/(?:youtu\.be\/|v=|embed\/|shorts\/)([A-Za-z0-9_-]{11})/);
  return m ? m[1] : null;
}

export function vidflowUrl(url) {
  const m = (url || "").match(/https?:\/\/[\w.-]*vidflow\.co\/\S+/);
  return m ? m[0] : null;
}

export function venueVideoEntry(url) {
  const id = ytId(url);
  if (id) return { key: id, type: "yt", id };
  const vf = vidflowUrl(url);
  if (vf) return { key: vf, type: "vidflow", url: vf };
  return null;
}

export function formatWeddingDate(value) {
  if (!value) return null;
  const d = new Date(`${value}T00:00:00`);
  if (Number.isNaN(d.getTime())) return value;
  return d.toLocaleDateString("en-GB", {
    weekday: "long",
    day: "numeric",
    month: "long",
    year: "numeric",
  });
}

const nameOf = (p) => (p.name || "").toLowerCase();

export function packageIncludesPhoto(p) {
  if (!p) return false;
  return (
    ["photo-collection", "photo-highlight", "photo-video"].includes(p.id) ||
    nameOf(p).includes("photo") ||
    (p.subtitle || "").toLowerCase().includes("photo")
  );
}

export function deriveQuoteTypeLabel(selectedPackages) {
  const hasPhoto = selectedPackages.some(
    (p) =>
      ["photo-collection", "photo-highlight", "photo-video"].includes(p.id) ||
      nameOf(p).includes("photo")
  );
  const hasVideo = selectedPackages.some(
    (p) =>
      ["video-collection", "photo-highlight", "photo-video"].includes(p.id) ||
      nameOf(p).includes("video") ||
      nameOf(p).includes("highlight")
  );
  if (hasPhoto && !hasVideo) return "Your Photo Quote";
  if (hasVideo && !hasPhoto) return "Your Video Quote";
  return "Your Photo & Video Quote";
}

export function deriveServices(selectedPackages) {
  const has = (fn) => selectedPackages.some(fn);
  const showHighlight = has(
    (p) => p.id === "photo-highlight" || nameOf(p).includes("highlight")
  );
  const showCinematic = has(
    (p) =>
      p.id === "video-collection" ||
      p.id === "photo-video" ||
      (nameOf(p).includes("video") && !nameOf(p).includes("highlight"))
  );
  const showPhotography = has(
    (p) =>
      ["photo-collection", "photo-highlight", "photo-video"].includes(p.id) ||
      nameOf(p).includes("photo")
  );
  const showContent = has(
    (p) => p.id === "content-creator-collection" || nameOf(p).includes("content creator")
  );
  const all = [
    {
      key: "content",
      show: showContent,
      title: "Content Creation",
      body:
        "Your own dedicated wedding content creator capturing your day vertically for Instagram, TikTok and Facebook. A sneak peek reel lands within 24 hours, followed by three fully edited social-ready reels, with every single raw clip transferred to you.",
      label: "View The Content Collection",
      href: "https://weddingvideoessex.co.uk/investment/the-content-collection",
    },
    {
      key: "highlight",
      show: showHighlight,
      title: "Highlight Films",
      body:
        "A music-driven highlights film that captures the look and atmosphere of your day in a beautifully edited 10–15 minute film. Filmed by one videographer, it offers lighter coverage while still capturing the key moments that matter most.",
      label: "View Highlight Video Examples",
      href: "https://weddingvideoessex.co.uk/investment/highlight-video",
    },
    {
      key: "cinematic",
      show: showCinematic,
      title: "Cinematic Story-Led Films",
      body:
        "A fully story-led wedding film documenting your day from start to finish. With two videographers and multiple cameras, your ceremony, speeches and formalities are captured in full with depth and perspective.",
      label: "View Cinematic Example Films",
      href: "https://weddingvideoessex.co.uk/wedding-video-gallery",
    },
    {
      key: "photography",
      show: showPhotography,
      title: "Photography",
      body:
        "Over 17 years of experience photographing weddings of every style and culture, from classic British weddings to Jewish, Indian, African, Afghan and Persian celebrations across Essex, London and Europe.",
      label: "View Photography Portfolio",
      href: "https://weddingvideoessex.co.uk/wedding-photography-gallery",
    },
  ];
  const visible = all.filter((s) => s.show);
  return visible.length ? visible : all;
}
